<!--- Formulario PCGestionPaletizado ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-
Eventos escuchados por el componente:
-----------------------

Eventos generados por el componente:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div>
    <f7-card
      v-if="editPale != null || manageReservation"
      class="content-gestion-paletizado"
    >
      <f7-card-header class="no-padding">
        <div
          :class="traspasos ? 'active' : null"
          @click="ChangeTabTraspasos"
        >
          {{ $t('commercialization.picking.palletizing.labels.transfers').toUpperCase() }}
        </div>
        <div
          v-if="!configuracionLecturaCajasFrmPicking.LecturaEnTraspaso"
          :class="{ active: reprocesados }"
          @click="ChangeTabReprocesados"
        >
          {{ $t('commercialization.picking.palletizing.labels.reprocessed').toUpperCase() }}
        </div>
      </f7-card-header>
      <f7-card-content class="no-padding">
        <div v-show="traspasos">
          <PCTransfer
            ref="componentTransfer"
            :selected-order-line="selectedOrderLine"
            :con-pedido="conPedido"
            :selected-edit-pale="editPale"
            :select-manage-reservation="selectManageReservation"
            @cancellation="PressCancel"
            @confirmation="Confirmar"
            @state-change="TransferStateChange"
          />
        </div>
        <div v-show="reprocesados">
          <PCReprocessed
            ref="componentReprocessed"
            :selected-order-line="selectedOrderLine"
            :selected-edit-pale="editPale"
            :con-pedido="conPedido"
            :select-manage-reservation="selectManageReservation"
            @cancellation="PressCancel"
            @confirmation="Confirmar"
            @state-change="ReprocesStateChange"
          />
        </div>
      </f7-card-content>
    </f7-card>
    <UCConfirmation ref="UCConfirmation" />
  </div>
</template>

<script>
import { useSettingRef } from '@erpagroapp/settings';
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import { ComponentState } from '@/js/common/enum';
import PCTransfer from '@/components/production/commercialization/picking/PCTransfer.vue';
import PCReprocessed from '@/components/production/commercialization/picking/PCReprocessed.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';

export default {

  name: 'PCGestionPaletizado',
  components: {
    PCTransfer,
    PCReprocessed,
    UCConfirmation,

  },
  props: {
    selectedEditPale: { type: Object, default: null },
    conPedido: { type: Boolean, default: true },
    selectManageReservation: {
      type: Boolean,
      default: false,
    },
    selectedOrderLine: {
      type: Object,
      default: null,
    },
  },

  emits: [
    'confirmation',
    'cancellation',
  ],

  data() {
    return {
      paletSelected: null, // palet seleccionado
      traspasos: true, // pestaña de traspasos
      reprocesados: false, // pestaña de reprocesados
      manageReservation: false, // se ha pulsado el btn de gestionar reserva
      traspasosState: 0,
      reprocesadosState: 0,
      editPale: null, // pale seleccionado
      configuracionLecturaCajasFrmPicking: {
        LecturaEnTraspaso: useSettingRef('Picking.LecturaCajas.LecturaEnTraspaso'),
      },
    };
  },
  watch: {
    selectedEditPale(val) {
      // this.editPale = val;
      if (val != null) {
        Log(this, 'PCGestionPaletizado->watch->selectedEditPale');
        this.SelectedEditPaleRecibed(val);
      }
    },
    selectManageReservation(val) {
      Log(this, 'PCGestionPaletizado->watch->selectManageReservation');
      this.manageReservation = val;
      this.traspasos = true;
      this.reprocesados = false;
      // this.ChangeTabTraspasos();
    },
  },
  mounted() {
    Log(this, 'PCGestionPaletizado->mounted');
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.mainData = {
        Base: null,
        Mercancia: [],
        TipoEnvasado: null,
        InfoNuevoPale: null,
      };
    },
    ResetComponent() {
      this.mainData = {
        Base: null,
        Mercancia: [],
        TipoEnvasado: null,
        InfoNuevoPale: null,
      };
      this.paletSelected = null;
      this.sumaTotalCajasTraspasar = 0;
      this.traspasos = true;
      this.reprocesados = false;
    },
    ChangeTabTraspasos() {
      Log(this, this.ChangeTabTraspasos.name);
      const self = this;
      if (this.reprocesadosState !== ComponentState.INITIAL) {
        this.$refs.UCConfirmation.create(
          this.$t('commercialization.picking.reprocessedNotSaved.title'),
          this.$t('commercialization.picking.reprocessedNotSaved.text'),
          () => {
            self.ResetComponent();
            self.traspasos = true;
            self.reprocesados = false;
            self.$refs.componentReprocessed.ResetComponent();
            self.$refs.componentReprocessed.StartComponent();
            // self.reprocesadosState = 0;
          },
        );
        this.$refs.UCConfirmation.show();
      } else {
        this.ResetComponent();
        this.traspasos = true;
        this.reprocesados = false;
      }
    },
    ChangeTabReprocesados() {
      Log(this, this.ChangeTabReprocesados.name);
      const self = this;
      if (this.traspasosState !== ComponentState.INITIAL) {
        this.$refs.UCConfirmation.create(
          this.$t('commercialization.picking.transferNotSaved.title'),
          this.$t('commercialization.picking.transferNotSaved.text'),
          () => {
            self.ResetComponent();
            self.traspasos = false;
            self.reprocesados = true;
            this.$refs.componentTransfer.ResetComponent();
            this.$refs.componentTransfer.StartComponent();
            // self.traspasosState = 0;
          },
        );
        this.$refs.UCConfirmation.show();
      } else {
        this.ResetComponent();
        this.traspasos = false;
        this.reprocesados = true;
      }
    },
    SelectedEditPaleRecibed(val) {
      this.editPale = val;
    },
    Confirmar(value) {
      Log(this, this.Confirmar.name);
      this.$emit('confirmation', value);
      this.ResetComponent();
    },
    PressCancel() {
      Log(this, this.PressCancel.name);
      this.$emit('cancellation');
      this.manageReservation = false;
      // this.ChangeTabTraspasos();
      this.ResetComponent();
    },
    TransferStateChange(val) {
      Log(this, this.TransferStateChange.name);
      this.traspasosState = val;
    },
    ReprocesStateChange(val) {
      Log(this, this.ReprocesStateChange.name);
      this.reprocesadosState = val;
    },

  },
};
</script>

<style scoped lang="scss">
.content-gestion-paletizado {
  .card-header {
    background-color: #f7f7f7;
    --f7-card-header-font-weight: 400;
    --f7-card-header-font-size: 14px;
    --f7-card-header-text-color: var(--his-plum-shadow);

    justify-content: flex-start;
    font-weight: 500;

    div {
      width: 160px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.active {
        background-color: #ebecf0;
        color: var(--his-ajo);
        font-weight: 600;
      }

      &:not(.active) {
        cursor: pointer;
      }
    }
  }

  .disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}
</style>
